/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 */

import { createSlice } from "@reduxjs/toolkit";

export const customerSlice = createSlice({
  name: "customer",
  initialState: {
    isDialogOpen: false,
    selectedCustomer: null,
    purpose: null,
  },
  reducers: {
    openCustomerDialog: (state, action) => {
      state.isDialogOpen = true;
      state.purpose = action.payload || null;
    },
    closeCustomerDialog: (state) => {
      state.isDialogOpen = false;
      state.purpose = null;
    },
    setSelectedCustomer: (state, action) => {
      state.selectedCustomer = action.payload;
    },
    clearSelectedCustomer: (state) => {
      state.selectedCustomer = null;
    },
  },
});

export const {
  openCustomerDialog,
  closeCustomerDialog,
  setSelectedCustomer,
  clearSelectedCustomer,
} = customerSlice.actions;

export const selectCustomer = (state) => state.customer;

export default customerSlice.reducer;
